import React, { memo } from 'react'

export default memo(() => (
  <svg width="1em" height="1em" viewBox="0 0 140 140" fill="none">
    <path d="M119.024 61.452L69.998 44.21 20.973 61.452l49.025 17.502 49.026-17.502z" fill="#23A4DE" />
    <path d="M119.022 61.452L69.996 44.21v34.744l49.026-17.502z" fill="#0061A8" />
    <path
      d="M88.553 8.837H50.318c-3.71 0-6.728 3.08-6.728 6.864v82.192c0 3.785 3.018 6.864 6.728 6.864h38.235c3.71 0 6.728-3.079 6.728-6.864V15.701c0-3.785-3.018-6.864-6.728-6.864z"
      fill="#262F69"
    />
    <path
      d="M88.529 12.81h-5.682a.98.98 0 00-.97.99c0 1.311-1.052 2.384-2.337 2.384H59.285c-1.286 0-2.338-1.073-2.338-2.385a.98.98 0 00-.97-.989h-5.682c-1.566 0-2.834 1.295-2.834 2.89V80.55h43.902V15.7c0-1.595-1.269-2.89-2.834-2.89z"
      fill="#fff"
    />
    <path d="M50.883 45.415l18.576-18.216 18.576 18.216v25.154H50.883V45.415z" fill="#262F69" />
    <path d="M50.883 45.415l18.576-18.216 18.576 18.216v14.312L50.883 45.415z" fill="#7BC9EB" />
    <path d="M88.036 70.57H77.162L61.758 34.751l7.702-7.553 18.576 18.216v25.154z" fill="#0061A8" />
    <path d="M88.036 45.415v14.312L69.46 52.66l-7.702-17.91L69.46 27.2l18.576 18.216z" fill="#32BCFA" />
    <path d="M69.998 79.002l-49.025-17.55v63.116l49.025 15.777V79.002z" fill="#31448F" />
    <path d="M119.022 124.568V61.451L69.996 79.002v61.343l49.026-15.777z" fill="#262F69" />
    <path d="M20.971 61.452L4 81.83l49.948 18.417 16.05-21.291L20.97 61.452z" fill="#7BC9EB" />
    <path d="M119.022 61.451l16.977 20.377-49.948 18.417-16.055-21.291 49.026-17.503z" fill="#23A4DE" />
    <rect
      width={12.682}
      height={12.724}
      rx={3}
      transform="matrix(.38391 -.92337 .9164 .40026 81 49.055)"
      fill="#FFE5C7"
    />
    <rect
      width={25.209}
      height={25.378}
      rx={5}
      transform="matrix(.89921 -.43752 .4491 .89348 20.223 18.03)"
      fill="#FFB71B"
    />
    <rect
      width={9.835}
      height={9.952}
      rx={2}
      transform="matrix(.9505 .3107 -.30262 .95311 100.012 11.857)"
      fill="#FFE5C7"
    />
    <defs>
      <clipPath id="prefix__clip0">
        <rect width="1em" height="1em" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
))
